import { useTranslation } from 'react-i18next';

export const useSubscriptionTypes = () => {
	const { t } = useTranslation('upsell');

	return [
		{ label: t('plural.monthly'), labelSingular: t('singular.monthly'), value: 1, disabled: false },
		{ label: t('plural.bimonthly'), labelSingular: t('singular.bimonthly'), value: 2, disabled: false },
		{ label: t('plural.quarterly'), labelSingular: t('singular.quarterly'), value: 3, disabled: false },
		{ label: t('plural.halfYearly'), labelSingular: t('singular.halfYearly'), value: 6, disabled: false },
		{ label: t('plural.annual'), labelSingular: t('singular.annual'), value: 12, disabled: false },
	];
};
